import { useState } from 'react';
import { useHotSearch } from '@/hooks/useHotSearch';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Input } from '@/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import { ChevronDown } from 'lucide-react';

const DrawerInput = ({ data, setQuery }) => {
  const [t] = useTranslation('analytics');
  const language = useSelector((state: any) => state.user.language);

  const [companyName, setCompanyName] = useState('');
  const { hotsearchCompanyList, getCompanyList } = useHotSearch();

  const selectCompany = async (e) => {
    setQuery({
      companyId: e.corp_code,
      companyName_ko: e[`corp_name_ko`],
      companyName_en: e[`corp_name_en`],
    });
  };

  const handleChange = (e: string) => {
    setCompanyName(e);
    getCompanyList(e);
  };

  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-4 m-4">
      <div className="w-full space-y-1">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild className="w-full">
            <div className="w-full relative text-center font-medium flex items-center gap-2 cursor-pointer bg-muted px-4 py-2 rounded-md">
              <ChevronDown className="w-4 h-4 absolute right-4" />
              {t('Select a company')}
            </div>
          </PopoverTrigger>
          <PopoverContent className="p-0 rounded-lg border shadow-md">
            <Command>
              <CommandInput
                value={companyName}
                onValueChange={handleChange}
                placeholder={t('Search company')}
              />
              <CommandList className="">
                <CommandEmpty>No results found.</CommandEmpty>
                <CommandGroup>
                  {hotsearchCompanyList.map((el) => (
                    <CommandItem
                      key={el.corp_code}
                      value={el.corp_name_ko}
                      onSelect={() => {
                        selectCompany(el);
                        setOpen(false);
                      }}
                    >
                      {el.corp_name_ko}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
      </div>
      {data?.companyId && (
        <div className="w-full space-y-1">
          <div className="font-medium">{t('Selected company')}</div>
          <div className="rounded-md bg-muted px-4 py-2 w-fit">
            {data[`companyName_${language}`]}
          </div>
        </div>
      )}
      <div className="w-full space-y-1">
        <div className="font-medium">{t('Tap name')}</div>
        <Input value={data?.tabName} onChange={(e) => setQuery({ tabName: e.target.value })} />
      </div>
    </div>
  );
};

export default DrawerInput;
